export function getCart (state) {
    return state.cartItems;
}


